const kWayMergeProblems = [
  {
      title: "Merge k Sorted Lists",
      url: "https://leetcode.com/problems/merge-k-sorted-lists/"
    },
    {
      title: "Kth Smallest Element in Sorted Matrix",
      url: "https://leetcode.com/problems/kth-smallest-element-in-a-sorted-matrix/"
    },
    {
      title: "Smallest Range covering Elements from K Lists",
      url: "https://leetcode.com/problems/smallest-range-covering-elements-from-k-lists/"
    },
    {
      title: "Ugly Number II",
      url: "https://leetcode.com/problems/ugly-number-ii/"
    },
    {
      title: "Find K Pairs with Smallest Sums",
      url: "https://leetcode.com/problems/find-k-pairs-with-smallest-sums/description/"
    }
];
export default kWayMergeProblems;